<!--
 * @Description: 累计监测里程、时长
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-18 11:38:37
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-29 16:56:00
 -->
<template>
  <div class="mileageAndTimeCount">
    <div class="item">
      <div class="valueContainer">
        <span class="value">{{mileage}}km</span>
      </div>
      <div class="label">累计监测里程</div>
    </div>
    <div class="item">
      <div class="valueContainer">
        <span class="value">{{duration}}天</span>
      </div>
      <div class="label">累计监测时长</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mileageAndTimeCount',
  components: {
  },
  data () {
    return {
      mileage: '',
      duration: '',
    }
  },
  methods: {
    /**
     * @description                   获取部署数据
     * @param   {String}              请求地址
     * @param   {type}                请求标志-区分里程还是时间
     * @return {undefied}             无返回值
     */
    getData (url, type) {
      this.$http.get(url, {
        productCode: 'lwtsgz',
      })
        .then(res => {
          if (res.code === 0) {
            if (type === 'mileage') {
              this.mileage = res.data.value
            } else if (type === 'duration') {
              this.duration = res.data.value
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getData('/rest/screen/product/mileage', 'mileage')
    this.getData('/rest/screen/product/duration', 'duration')
  },
}
</script>

<style lang="less" scoped>
  .mileageAndTimeCount {
    width: 100%;
    height: 100%;
    display: inline-flex;
    justify-content: space-around;
    .item {
      width: 40%;
      text-align: center;
      .valueContainer {
        height: 70%;
        aspect-ratio: 1.2/1;
        background: url('/static/img/layout/mileage.png');
        background-size: 100% 100%;
        position: relative;
        margin: 0 auto;
        .value {
          display: block;
          width: 100%;
          position: absolute;
          left: 0;
          top: 31%;
          font-family: MicrosoftYaHei-Bold;
          font-size: 2.3vh;
          font-weight: bold;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #fefefe;
          background-image: -webkit-linear-gradient(top, rgb(255, 255, 255), rgb(129, 202, 200));
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      .label {
        width: 100%;
        text-align: center;
        font-size: 1.5vh;
        color: #fff;
        font-weight: bold;
        margin-top: 7%;
      }
    }
  }
</style>
